export default __webpack_public_path__ + "static/media/customize_black.9c4680e8.svg";